import {TableDefinition} from '~/backend/src/connectors/db/dbDefinition/DbDefinitionMapperUtilities';


const tableDefinition : TableDefinition = {
    table          : 'CI_PROPERTY',
    fieldMap       : {
        id              : 'CIP_ID',
        key             : 'CIP_KEY',
        value           : 'CIP_VALUE',
        itemId          : 'CIP_CI_ID',
        propertySetId   : 'CIP_CIPS_ID',
        statusId        : 'CIP_CIST_ID',
        modifierUserId  : 'CIP_MODIFIER',
        modificationTime: 'CIP_MODIFICATION_TIME',
        validatorUserId : 'CIP_VALIDATOR',
        validationTime  : 'CIP_VALIDATION_TIME'
    },
    historyFieldMap: {
        id            : 'CIP_ID',
        key           : 'CIP_KEY',
        value         : 'CIP_VALUE',
        itemId        : 'CIP_CI_ID',
        propertySetId : 'CIP_CIPS_ID',
        statusId      : 'CIP_CIST_ID',
        modifierUserId: 'CIP_MODIFIER',
        validFromTime : 'CIP_VALID_FROM',
        validToTime   : 'CIP_VALID_TO'
    },
    fieldTypesMap  : {
        id              : 'INTEGER',
        key             : 'STRING',
        value           : 'STRING',
        itemId          : 'INTEGER',
        propertySetId   : 'INTEGER',
        statusId        : 'INTEGER',
        modifierUserId  : 'STRING',
        modificationTime: 'TIMESTAMP',
        validatorUserId : 'STRING',
        validationTime  : 'TIMESTAMP',
        validFromTime   : 'TIMESTAMP',
        validToTime     : 'TIMESTAMP'
    }
};

export default tableDefinition;
